"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChromeStorage = void 0;
const StorageKeyReturnDefaults_1 = require("../types/storage/StorageKeyReturnDefaults");
class ChromeStorage {
    static async isSupported() {
        return Promise.resolve(typeof window !== 'undefined' &&
            typeof chrome !== 'undefined' &&
            chrome &&
            chrome.runtime &&
            !!chrome.runtime.id);
    }
    async get(key) {
        return new Promise((resolve) => {
            chrome.storage.local.get(null, (storageContent) => {
                if (storageContent[key]) {
                    resolve(storageContent[key]);
                }
                else {
                    if (typeof StorageKeyReturnDefaults_1.defaultValues[key] === 'object') {
                        resolve(JSON.parse(JSON.stringify(StorageKeyReturnDefaults_1.defaultValues[key])));
                    }
                    else {
                        resolve(StorageKeyReturnDefaults_1.defaultValues[key]);
                    }
                }
            });
        });
    }
    async set(key, value) {
        return new Promise((resolve) => {
            chrome.storage.local.set({ [key]: value }, () => {
                resolve();
            });
        });
    }
    async delete(key) {
        return new Promise((resolve) => {
            chrome.storage.local.set({ [key]: undefined }, () => {
                resolve();
            });
        });
    }
}
exports.ChromeStorage = ChromeStorage;
//# sourceMappingURL=ChromeStorage.js.map